import React, { useState } from 'react';
import { ChevronDown, StarFill } from 'react-bootstrap-icons';
import analyticsService from '../../services/analyticsService';

/**
 * Expandable section - title + content, collapsed by default.
 * Matches Home page ExpandableItem pattern.
 */
const ExpandableItem = ({ title, content, titleIcon, analyticsSection = 'landing', analyticsId }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded((prev) => {
      const next = !prev;
      if (next) {
        analyticsService.trackTradingEvent?.('landing_expandable_expanded', {
          section: analyticsSection,
          item_id: analyticsId || undefined,
          item_title: title || undefined,
        });
      }
      return next;
    });
  };

  return (
    <div className="landing-expandable-item">
      <h3
        className="landing-expandable-title"
        onClick={toggleExpanded}
      >
        <span className="landing-expandable-title-main">
          {titleIcon === 'star' ? (
            <StarFill
              className="landing-expandable-title-icon landing-expandable-title-icon--gold"
              size={16}
              aria-hidden
            />
          ) : null}
          <span className="landing-expandable-title-text">{title}</span>
        </span>
        <span className={`landing-expandable-chevron ${isExpanded ? 'expanded' : ''}`}>
          <ChevronDown size={16} />
        </span>
      </h3>
      {isExpanded && (
        <p className="landing-expandable-content" dangerouslySetInnerHTML={{ __html: content }} />
      )}
    </div>
  );
};

export default ExpandableItem;
